
















import Vue from "vue";
import store from "../store";
import {RAMBLINGS_ROUTE_NAME} from '@/router';

export default Vue.extend({
	name      : "book",
	components: {},
	props     : {
		bookKey: {
			type    : String,
			required: true,
		},
		seed   : {
			type: String,
			validator(value: string) {
				const cast = Number(value);
				return Number.isInteger(cast) && cast < 1000 && cast > 0;
			},
		},
	},
	computed: {
		title() {
			return this.$route.name === RAMBLINGS_ROUTE_NAME
				? 'The Ramblings of a Madman'
				: 'An Obscure Passage';
		},
	},
	beforeRouteEnter(to, from, next) {
		store.dispatch("changeBook", {
			bookKey: to.params.bookKey,
			seed   : Number(to.params.seed) / 1000,
		})
			.then(() => {
				next();
			})
			.catch((error) => {
				next(error);
			});
	},
	beforeRouteUpdate(to, from, next) {
		store.dispatch("changeBook", {
			bookKey: to.params.bookKey,
			seed   : Number(to.params.seed) / 1000,
		})
			.then(() => {
				next();
			})
			.catch((error) => {
				next(error);
			});
	},
});
